import {OnInit, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ContactNoId} from '../../../classes/json-interface';

@Component({
  templateUrl: './dialog-contact.component.html',
  styleUrls: ['./dialog-contact.component.css']
})
export class DialogContactComponent implements OnInit {

  public static async openDialog(dialog: MatDialog,
                                 dialogData: Partial<ContactNoId> = {}): Promise<ContactNoId | undefined> {
    const openedDialog = dialog.open(DialogContactComponent, {data: dialogData, disableClose: true});
    return openedDialog.afterClosed().toPromise();
  }

  public dialogData: Partial<ContactNoId>;

  constructor(public mDialogRef: MatDialogRef<DialogContactComponent>,
              @Inject(MAT_DIALOG_DATA) dialogData: Partial<ContactNoId>) {
    this.dialogData = { ...dialogData }; // Copie des données
  }

  ngOnInit() {

  }

  onBtnClick(save: boolean) {
    if (save)
      this.mDialogRef.close({...this.dialogData});
    else
      this.mDialogRef.close(undefined);
  }

}
